export const SITE = {
  name: "Magali Clouzet",
  role: "Consultante marketing stratégique",
  email: "contact@magaliclouzet.com",
  linkedin: "https://www.linkedin.com/in/magaliclouzet/",
  calendly: "https://calendly.com/contact-magaliclouzet",
  baseline: "Transformez votre marketing en vrai levier de croissance",
  zones: "Nice · Sophia Antipolis · Cannes · Antibes · Monaco · Alpes-Maritimes · France et international (remote)",
};

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Qui suis-je ?", to: "/qui-suis-je" },
  { label: "Mes services", to: "/services" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroAbstract: "/assets/consultant-strategie-marketing-pme-nice-sophia-antipolis.webp",
  offer1: "/assets/audit-diagnostic-marketing-strategique-pme.webp",
  offer2: "/assets/strategie-lancement-produit-go-to-market-start-up.webp",
  offer3: "/assets/direction-marketing-externalisee-fractional-cmo-pme.webp",
  blog: [
    "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf",
    "https://images.unsplash.com/photo-1499750310107-5fef28a66643",
    "https://images.pexels.com/photos/7071/space-desk-office-workspace.jpg",
  ],
};
